import { FC } from 'react'
import { makeStyles } from '@material-ui/core'
const useStyles = makeStyles(() => ({
  featureDot: {
    height: '8px',
    width: '8px',
    borderRadius: '50%',
    backgroundColor: 'var(--goto-interactive-color-neutral-default)',
  },
  featureDotActive: {
    height: '8px',
    width: '8px',
    borderRadius: '50%',
    backgroundColor: 'var(--goto-interactive-color-primary-default)',
  },
}))

interface FeatureDotsProps {
  isActive: boolean
}

const FeatureDots: FC<FeatureDotsProps> = ({ isActive }): JSX.Element => {
  const classes = useStyles()
  return <div className={isActive ? classes.featureDotActive : classes.featureDot} />
}

export default FeatureDots
